import { defineComponent as _defineComponent } from 'vue'
import {
  computed, getCurrentInstance, nextTick, onBeforeUpdate, onMounted, ref,
} from 'vue';
import AppCard from '@/components/views/settings/apps/AppCard.vue';
import MainToolbar from '@/components/views/main/MainToolbar.vue';
import store from '@/store/store';
import i18n from '@/plugins/i18n';
import { useRoute } from 'vue-router/composables';
import GstplnApp, { GstplnAppCategory } from '../apps/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'Apps',
  setup(__props) {

const route = useRoute();

const categoryFilter = ref(route.query.category as string || '');
const categories = [
  { text: i18n.tc('label.show_all'), value: '' },
  { divider: true },
  { text: i18n.tc('code.app_category.extensions'), value: GstplnAppCategory.Extensions },
  { text: i18n.tc('code.app_category.booking_partners'), value: GstplnAppCategory.BookingPartners },
  { text: i18n.tc('code.app_category.integrations'), value: GstplnAppCategory.Integrations },
  { text: i18n.tc('code.app_category.payments'), value: GstplnAppCategory.Payments },
];

const showOnlyInstalled = ref(false);
const installedApps = computed(() => store.getters.gstplnApps.filter((a: GstplnApp) => a.installed));

const apps = computed(() => (showOnlyInstalled.value ? installedApps.value : store.getters.gstplnApps) as GstplnApp[]);
const filteredApps = computed(
  () => (categoryFilter.value === ''
    ? apps.value
    : apps.value.filter((a) => a.categories.includes(categoryFilter.value))),
);

// open config settings from route
const appCards = ref(new Map<string, InstanceType<typeof AppCard>>());
const setAppCard = (ac: InstanceType<typeof AppCard>) => appCards.value.set(ac.$props.app.apiName, ac);
onBeforeUpdate(() => {
  appCards.value = new Map<string, InstanceType<typeof AppCard>>();
});
onMounted(() => {
  // test app configure request
  const appName = route.query.configure as string;
  if (!appName) return;

  // wait until loaded
  const unwatch = store.watch((state, getters) => getters.isLoaded, async (newValue, oldValue) => {
    if (!newValue) return;
    const appCard = appCards.value.get(appName);
    console.log('appCard: ', appCard, 'appCards: ', appCards.value);
    appCard?.goToApp(true);
    await nextTick(); // for immedated unwatch is not yet set
    unwatch();
  }, { immediate: true });
});


return { __sfc: true,route, categoryFilter, categories, showOnlyInstalled, installedApps, apps, filteredApps, appCards, setAppCard, AppCard, MainToolbar }
}

})